import { createContext, useContext } from 'react';
import useGroupPermissions from '../hooks/useGroupPermissions';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { groupPermissions, loading: permsLoading, error: permsError } = useGroupPermissions();

  const isUnknownUser = groupPermissions.length === 0;

  return (
    <AuthContext.Provider
      value={{
        userPermissions: groupPermissions,
        isUnknownUser,
        permsLoading,
        permsError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return ctx;
}
